import Vue from 'vue'
import VueRouter from 'vue-router'
/* import store from '../store'
import _ from 'lodash' */

/* // Reseller Auth
import ResellerAuth from './reseller-auth'

// Dashboard
import Dashboard from './dashboard'

// unauthorized
import Unauthorized from './unauthorized' */

// Authentication
import Auth from './auth'

// User Management
// import UserManagement from './user-management'

/* // POS
import PosService from './pos'

// Orders
import OrderService from './order'

// Shopping Service
import ShoppingServices from './shopping-service'

// Settings
import Settings from './settings'

// Global Search
import GlobalSearch from './search-result'

// Tools
import Tools from './tools'

// Reports
import Reports from './reports'

// CMS
import CMS from './cms'

// Manage User
import CRM from './crm' */

// AI Agent
import AIAgent from './ai-agent'

Vue.use(VueRouter)

const routes = [

  // Root
  {
    path: '/',
    redirect: { name: 'ai-agent' }
  },

  // Setup Page
  {
    path: '/setup',
    name: 'setup',
    component: () => import('../components/Pages/LandingPage/SetupPage.vue')

  },

  // Authentication
  ...Auth,
  /* // Reseller Auth
  ...ResellerAuth,

  // Unauthorized
  ...Unauthorized,

  // Dashboard
  ...Dashboard, */

  // AI Agent
  ...AIAgent

  // User Management
  // ...UserManagement

  /* // Order
  ...OrderService,

  // Shopping Services
  ...ShoppingServices,

  // Global Search
  ...GlobalSearch,

  // Tools
  ...Tools,

  // Reports
  ...Reports,

  // CRM
  ...CRM,

  // CMS
  ...CMS,

  // Settings
  ...Settings,

  // POS
  ...PosService */

]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0) // Scroll to top
  var currentRoute = to.path
  console.log('Current path' + currentRoute)
  const loggedIn = localStorage.getItem('accessToken')
  const publicRoutes = ['/login', '/register', '/forgotpassword', '/login-preview', '/auth/sso', '/auth/sso-error']
  const allowedForLoggedInUsers = ['/search/result', '/manage-member', '/profile/view', '/profile/changepassword', '/ai-agent', '/ai-agent/dashboard', '/setup']
  const isAllowedForLoggedInUsers = allowedForLoggedInUsers.some(element => currentRoute.includes(element))

  var isPublicRoute = publicRoutes.includes(currentRoute)
  if (currentRoute.includes('/resetpassword') || currentRoute.includes('/reseller-auth') || currentRoute.includes('/setpassword')) {
    isPublicRoute = true
  }
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (!isPublicRoute && !loggedIn) {
    next('/auth/sso-error')
  } else if (!isPublicRoute && loggedIn && currentRoute !== '/unauthorized' && isAllowedForLoggedInUsers) {
    next()
  } else if (!isPublicRoute && loggedIn && currentRoute !== '/unauthorized') {
    /* store.dispatch('auth/fetchAndSetPermissions').then((response) => {
      var pathName = currentRoute.split('/')[1].toLowerCase()
      var permissions = response
      var isAuthorized = _.find(permissions, function (p) {
        return p.PrivilegeName.toLowerCase().includes(pathName) && p.Label === 1
      })
      if (isAuthorized) {
        next()
      } else {
        router.push({
          name: 'unauthorized'
        })
      }
    }) */
    next()
  } else {
    next()
  }
})

export default router
